
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-compatibility-helpers/-embroider-implicit-modules.js";
import "ember-destroyable-polyfill/-embroider-implicit-modules.js";
import "ember-modifier-manager-polyfill/-embroider-implicit-modules.js";
